import {
  FadvBaseDatePicker
} from "./chunk.374AFDAL.js";
import {
  isMobile
} from "./chunk.XRUCOIZT.js";
import {
  createDatePickerMaskOptions
} from "./chunk.EY5SW4NC.js";
import {
  formatForDateInput,
  getDateFromDateInput
} from "./chunk.HLRT5FOM.js";
import {
  IMask
} from "./chunk.7I2462UJ.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  dateRangeAttributeConverter
} from "./chunk.MIOPVZYG.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  setDefaultAnimation
} from "./chunk.456HIP2G.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/date-picker/date-range-picker.ts
import { t } from "i18next";
var FadvDateRangePicker = class extends FadvBaseDatePicker {
  constructor() {
    super(...arguments);
    this.toInputId = `${this.inputId}_to`;
    this.fromInputId = `${this.inputId}_from`;
  }
  async firstUpdated() {
    await this.updateComplete;
    this.handlePatternChange();
  }
  handlePatternChange() {
    var _a, _b;
    (_a = this.startDateMask) == null ? void 0 : _a.destroy();
    this.startDateMask = void 0;
    (_b = this.endDateMask) == null ? void 0 : _b.destroy();
    this.endDateMask = void 0;
    if (this.datePattern) {
      const options = createDatePickerMaskOptions(this.datePattern, this.min, this.max);
      this.startDateMask = IMask(this.startDate, options);
      this.endDateMask = IMask(this.endDate, options);
    }
  }
  handleRangeStartChange() {
    this.endDate.value = "";
    this.value = void 0;
    this.calendar.rangeStart = void 0;
    this.calendar.rangeEnd = void 0;
    let start;
    if (this.startDateMask) {
      start = this.startDateMask.typedValue;
    } else {
      start = getDateFromDateInput(this.startDate);
    }
    if (start && !this.isInRange(start)) {
      this.startDate.value = "";
      return;
    }
    this.calendar.rangeStart = start;
    if (isMobile() && this.calendar.rangeStart) {
      this.endDate.focus();
    }
    this.emitValue();
  }
  handleRangeEndChange() {
    const start = this.value && this.value[0];
    let end;
    if (this.endDateMask) {
      end = this.endDateMask.typedValue;
    } else {
      end = getDateFromDateInput(this.endDate);
    }
    if (end && !this.isInRange(end) || start && end && start > end) {
      if (this.value) {
        this.value[1] = void 0;
      }
      this.calendar.rangeEnd = void 0;
    } else {
      this.calendar.rangeEnd = end;
    }
    this.emitValue();
  }
  emitValue() {
    this.value = [this.calendar.rangeStart, this.calendar.rangeEnd];
    emit(this, "fadv-calendar-range-change", { detail: { rangeStart: this.calendar.rangeStart, rangeEnd: this.calendar.rangeEnd } });
  }
  handleCalendarRangeChange(e2) {
    const { rangeStart, rangeEnd } = e2.detail;
    if (this.datePattern && this.startDateMask && this.endDateMask) {
      this.startDateMask.value = this.getPatternFormattedDate(rangeStart);
      this.startDateMask.updateValue();
      this.endDateMask.value = this.getPatternFormattedDate(rangeEnd);
      this.endDateMask.updateValue();
    } else {
      this.startDate.value = formatForDateInput(rangeStart) || "";
      this.endDate.value = formatForDateInput(rangeEnd) || "";
    }
    this.value = [rangeStart, rangeEnd];
    if (this.value[0] && this.value[1]) {
      this.open = false;
    }
  }
  focus() {
    this.startDate.focus();
  }
  blur() {
    this.startDate.blur();
    this.endDate.blur();
  }
  clear() {
    this.startDate.value = "";
    this.endDate.value = "";
    this.value = void 0;
  }
  renderCalendar() {
    return $`<fadv-calendar range hidden role="menu" aria-hidden=${!this.open} aria-label=${this.label} date-pattern=${this.datePattern} range-start=${l(this.value ? this.value[0] : void 0)} range-end=${l(this.value ? this.value[1] : void 0)} min-date=${l(this.min)} max-date=${l(this.max)} @fadv-calendar-range-change=${this.handleCalendarRangeChange} ></fadv-calendar>`;
  }
  getInputLabelledBy(inputId) {
    const labelledBy = [
      this.label || this.hasSlotController.test("label") ? this.labelId : "",
      inputId,
      this.helpText || this.hasSlotController.test("help-text") ? this.helpTextId : ""
    ].filter((val) => val);
    return labelledBy.join(" ") || void 0;
  }
  getToMax() {
    if (!this.value || !this.value[1])
      return formatForDateInput(this.max);
    return formatForDateInput(this.value[1]);
  }
  getFromMin() {
    if (!this.value || !this.value[0])
      return formatForDateInput(this.min);
    return formatForDateInput(this.value[0]);
  }
  renderInput() {
    return $`<div class="form-control__control"><fadv-typography type="label-xx-small">${t("components:calendar.from")}:</fadv-typography><input class="start__date" required size="1" id=${this.fromInputId} type=${this.datePattern ? "text" : "date"} name=${l(this.name)} ?disabled=${this.disabled} ?readonly=${this.readonly} min=${l(formatForDateInput(this.min))} max=${l(this.getToMax())} ?autofocus=${this.autofocus} .value=${l2(this.getDateInputValue(this.value && this.value[0]))} placeholder=${this.datePattern && !this.placeholder ? this.datePattern.toLowerCase() : this.placeholder} aria-invalid=${this.invalid ? "true" : "false"} aria-label=${t("components:calendar.from")} aria-labelledby=${l(this.getInputLabelledBy(this.fromInputId))} @change=${this.handleRangeStartChange} @focus=${this.handleInputFocus} @blur=${this.handleBlur} @click=${this.handleInputClick} @keydown=${this.handleInputKeydown} /><fadv-typography type="label-xx-small">${t("components:calendar.to")}:</fadv-typography><input class="end__date" required size="1" id=${this.toInputId} type=${this.datePattern ? "text" : "date"} name=${l(this.name)} ?disabled=${this.disabled} ?readonly=${this.readonly} min=${l(this.getFromMin())} max=${l(formatForDateInput(this.max))} ?autofocus=${this.autofocus} .value=${l2(this.getDateInputValue(this.value && this.value[1]))} placeholder=${this.datePattern && !this.placeholder ? this.datePattern.toLowerCase() : this.placeholder} aria-invalid=${this.invalid ? "true" : "false"} aria-label=${t("components:calendar.to")} aria-labelledby=${this.getInputLabelledBy(this.toInputId)} @change=${this.handleRangeEndChange} @focus=${this.handleInputFocus} @blur=${this.handleBlur} @click=${this.handleInputClick} @keydown=${this.handleInputKeydown} /></div>`;
  }
};
__decorateClass([
  e({ reflect: true, converter: dateRangeAttributeConverter })
], FadvDateRangePicker.prototype, "value", 2);
__decorateClass([
  i("input.start__date")
], FadvDateRangePicker.prototype, "startDate", 2);
__decorateClass([
  i("input.end__date")
], FadvDateRangePicker.prototype, "endDate", 2);
__decorateClass([
  watch("datePattern", { waitUntilFirstUpdate: true })
], FadvDateRangePicker.prototype, "handlePatternChange", 1);
FadvDateRangePicker = __decorateClass([
  n("fadv-date-range-picker")
], FadvDateRangePicker);
setDefaultAnimation("date-picker.show", {
  keyframes: [
    { opacity: 0, transform: "scale(0.9)" },
    { opacity: 1, transform: "scale(1)" }
  ],
  options: { duration: 150, easing: "ease" }
});
setDefaultAnimation("date-picker.hide", {
  keyframes: [
    { opacity: 1, transform: "scale(1)" },
    { opacity: 0, transform: "scale(0.9)" }
  ],
  options: { duration: 150, easing: "ease" }
});

export {
  FadvDateRangePicker
};
